
import { ServiceTokens } from "$src/domain/ServiceTokens";
import { DocumentIdentifier } from "$src/domain/projects/documents/DocumentIdentifier";
import { DocumentUpload } from "$src/domain/projects/documents/DocumentUpload";
import type { IDocumentRepository } from "$src/domain/projects/documents/IDocumentRepository";
import { documentRefresh, documentUploads } from "$src/infrastructure/projects/documents/uploadDocumentStore";
import { AxiosProgressEvent } from "axios";
import { inject, injectable } from "tsyringe";

@injectable()
export class CreateDocument {
    
    constructor(@inject(ServiceTokens.DocumentRepository) private documentRepository: IDocumentRepository) {}

    async execute(groupStoreId: number, projectId: number, file: File): Promise<DocumentIdentifier> {

        const uploadId = `${Date.now()}-${Math.random()}`;
        const documentUpload: DocumentUpload = 
        {
            id: uploadId,
            name: file.name,
            progress: 0, 
            error: null, 
            isUploading: true 
        };

        documentUploads.update(us => [...us, documentUpload]);

        try {
            var identifier = await this.documentRepository.createDocument(groupStoreId, projectId, file, 
                (progressEvent: AxiosProgressEvent) => {
                    //upload progress
                    if (progressEvent.total) {
                      const percentComplete = (progressEvent.loaded / progressEvent.total) * 100;
                      documentUploads.update(us => {
                        const idx = us.findIndex(u => u.id === uploadId);
                        if (idx !== -1) {
                          us[idx].progress = percentComplete;
                        }
                        return us;
                      });
                    }
                }
            );

            //upload done
            documentUploads.update(us => {
                const idx = us.findIndex(u => u.id === uploadId);
                if (idx !== -1) {
                    us[idx].isUploading = false;
                    us[idx].progress = 100;

                    documentRefresh.update(counter => counter + 1);
                    
                    setTimeout(() => {
                        this.removeUpload(uploadId);
                    }, 3000);
                }
                return us;
            });

            return identifier;
        }
        catch(error) {

            //upload error
            documentUploads.update(us => {
                const idx = us.findIndex(u => u.id === uploadId);
                if (idx !== -1) {
                  us[idx].error = error;
                  us[idx].isUploading = false;
                }
                return us;
            });

            throw error; 
        }
    }

    removeUpload(id: string) {
        documentUploads.update(us => us.filter(u => u.id !== id));
    }
}

export const CreateDocumentToken = Symbol('CreateDocumentToken');    
